import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API_BASE = 'https://bunny-klawz.uc.r.appspot.com';

const truncateWithEllipses = (str) => {
    return str.length > 35 ? str.slice(0, 32) + '...' : str;
};

const Clients = () => {
    const [users, setUsers] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [instagramInput, setInstagramInput] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    const fetchUsers = async () => {
        try {
            const res = await axios.get(`${API_BASE}/users`);
            setUsers(res.data.map(user => ({ ...user })));
        } catch (err) {
            console.error(err);
        }
    };

    const toggleBlock = async (user) => {
        const route = user.blocked ? 'unblock' : 'block';
        await axios.post(`${API_BASE}/users/${encodeURIComponent(user.user_id)}/${route}`);
        fetchUsers();
    };

    const handleEdit = (user) => {
        setEditingId(user.user_id);
        setInstagramInput(user.app_metadata?.instagram || '');
    };

    const saveInstagram = async (userId) => {
        await axios.patch(`${API_BASE}/users/${encodeURIComponent(userId)}`, {
            app_metadata: { instagram: instagramInput }
        });

        setUsers(prev =>
            prev.map(u =>
                u.user_id === userId
                    ? { ...u, app_metadata: { ...u.app_metadata, instagram: instagramInput } }
                    : u
            )
        );

        setEditingId(null);
    };

    const deleteUser = async (userId) => {
        await axios.delete(`${API_BASE}/users/${encodeURIComponent(userId)}`);
        fetchUsers();
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    return (
        <div style={{ padding: '2rem' }}>
            {/* <h2>Clients</h2> */}
            <div className="UserSearch" style={{ marginBottom: '1rem' }}>
                <input
                    placeholder="Search by name, email, or Instagram"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ width: '100%', padding: '0.5rem', fontSize: '1rem' }}
                />
            </div>

            <div className="UserList">
                {users
                    .filter(user => {
                        const name = (user.name || user.nickname || '').toLowerCase();
                        const email = (user.email || '').toLowerCase();
                        const instagram = (user.app_metadata?.instagram || '').toLowerCase();
                        const query = searchTerm.toLowerCase();
                        return (
                            name.includes(query) ||
                            email.includes(query) ||
                            instagram.includes(query)
                        );
                    })
                    .map(user => (
                        <div key={user.user_id} className="UserCard">
                            <div className="UserField"><strong>Name:</strong> {truncateWithEllipses(user.name || user.nickname)}</div>
                            <div className="UserField"><strong>Email:</strong> {truncateWithEllipses(user.email)}</div>
                            <div className="UserField">
                                <strong>Insta:</strong>{' '}
                                {editingId === user.user_id ? (
                                    <input
                                        className="InstagramInput"
                                        value={instagramInput}
                                        onChange={(event) => {
                                            let value = event.target.value;

                                            // Remove all spaces
                                            value = value.replaceAll(" ", "");

                                            // Ensure it starts with '@'
                                            if (!value.startsWith("@")) {
                                                value = "@" + value.replace(/^@+/, ""); // avoid multiple '@'
                                            }

                                            // Limit to 33 characters
                                            if (value.length > 33) {
                                                value = value.slice(0, 33);
                                            }

                                            setInstagramInput(value);
                                        }}
                                        placeholder="Enter Instagram handle"
                                    />
                                ) : (
                                    user.app_metadata?.instagram || <i className="InstagramNone">None</i>
                                )}
                            </div>
                            <div className="UserActions">
                                <button onClick={() => toggleBlock(user)}>
                                    {user.blocked ? 'Unblock' : 'Block'}
                                </button>
                                {editingId === user.user_id ? (
                                    <button onClick={() => saveInstagram(user.user_id)}>Save</button>
                                ) : (
                                    <button onClick={() => handleEdit(user)}>
                                        {user.app_metadata?.instagram ? 'Edit Instagram' : 'Add Instagram'}
                                    </button>
                                )}
                                {/* <button onClick={() => deleteUser(user.user_id)}>Delete</button> */}
                            </div>
                        </div>
                    ))}
            </div>

        </div>
    );
};

const th = { textAlign: 'left', padding: '0.5rem', borderBottom: '2px solid #000' };
const td = { padding: '0.5rem' };

export default Clients;
